import client from "../client";
import { ApprovalPersonInterface } from "../../models/ProcurementModule/ApprovalPerson";

const listName = "ApprovalPersons";
class ApprovalPersonService {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<ApprovalPersonInterface[]>(
        `/api/${listName}/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<ApprovalPersonInterface>(
        `/api/${listName}/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: ApprovalPersonInterface) {
    try {
      const { data } = await client.post<ApprovalPersonInterface>(
        `/api/${listName}/create`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: ApprovalPersonInterface) {
    try {
      const { data } = await client.post<ApprovalPersonInterface>(
        `/api/${listName}/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<ApprovalPersonInterface>(
        `/api/${listName}/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new ApprovalPersonService();
